import React from 'react';

const DocumentRow = ({
  documentData,
  isDoc1,
  data,
  comparisonID,
  setDocName,
  docName,
  trStyle,
  verticalLabel,
  containsPropVal,
  tdPropStyle,
  tdValueStyle
}) => {
  const handleNameChange = async () => {
    const fieldName = isDoc1 ? "doc1_name" : "doc2_name";
    const currentName = isDoc1 ? data?.doc1_name : data?.doc2_name;
    const newName = window.prompt("Enter a new name:", currentName || "Unnamed");
    
    if (newName !== null && newName.trim() !== "") {
      try {
        const claimId = comparisonID;
        if (!claimId) {
          console.error("ERROR: Claim ID is missing!");
          alert("Error: Claim ID is missing.");
          return;
        }
        
        const requestBody = JSON.stringify({ [fieldName]: newName });
        const response = await fetch(`${process.env.REACT_APP_DOCNAMES}/${claimId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: requestBody,
        });
        
        const result = await response.json();
        if (!response.ok) {
          throw new Error(result.error || "Failed to update the database");
        }
        
        alert("Database updated successfully!");
        setDocName(newName);
      } catch (error) {
        console.error("ERROR:", error);
        alert("Failed to update the database. Please try again.");
      }
    }
  };

  return (
    <tr style={trStyle}>
      <th style={verticalLabel}>
        <span
          style={{
            cursor: "pointer",
            color: "#00B3B5",
            textDecoration: "underline",
            zIndex: "1000",
          }}
          className={isDoc1 ? "doc1" : "doc2"}
          onClick={handleNameChange}
        >
          {docName || "Unnamed"}
        </span>
      </th>
      
      {Object.entries(documentData).slice(1).map(([key, value]) => (
        <td style={containsPropVal} key={key}>
          <td style={tdPropStyle}>{key}</td>
          <td style={tdValueStyle}>{value}</td>
        </td>
      ))}
    </tr>
  );
};

export default DocumentRow;
